import React, { useState } from "react";
import { useEffect } from "react";
import styled, { css } from "styled-components";

const CustomButton = styled.button`
    font-size: 16px;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    padding: 10px 12px;
    background-color: #fff;
    border: 1px solid var(--light-color);
    border-radius: 8px;
    transition: all ease 0.2s;
    cursor: pointer;

    &:disabled {
        background-color: var(--disabled);
        border-color: var(--disabled);
        color: var(--white-color);
        cursor: not-allowed;
    }
    &:not(:disabled):hover {
        background-color: var(--light-color);
        border-color: var(--light-color);
    }

    ${({ type, active }) => {
        let returnCss = "";

        // active
        if (active) {
            returnCss += `
            background-color: var(--lightgray-color);
            border-color: var(--lightgray-color);
            `;
        }

        // dark
        if (type && type === "dark") {
            returnCss += `
                background-color: var(--dark-color);
                border-color: var(--dark-color);

                &:not(:disabled):hover {
                    background-color: var(--gray-color);
                    border-color: var(--gray-color);
                }`;

            if (active) {
                returnCss += `
                    background-color: var(--darkgray-color);
                    border-color: var(--darkgray-color);
            `;
            }
        }
        // default, base
        else if (type && type !== "default" && type !== "base") {
            returnCss += `
            background-color: var(--${type}-color);
            border-color: var(--${type}-color);
            
            &:not(:disabled):hover {
                background-color: var(--${type}-light-color);
                border-color: var(--${type}-light-color);
            }`;

            if (active) {
                returnCss += `
                    background-color: var(--${type}-dark-color);
                    border-color: var(--${type}-dark-color);
            `;
            }
        }

        if (type === "main" || type === "highlight" || type === "deep" || type === "dark" || type === "main-dark" || type === "main-point") {
            returnCss += `color: #fff;`;
        }

        return css`
            ${returnCss}
        `;
    }}
`;

const Button = ({ children, ...props }) => {
    let { type, disabled, active } = props;

    return (
        <>
            <CustomButton {...props} disabled={disabled} active={active}>
                {children}
            </CustomButton>
        </>
    );
};

export default Button;
